var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBellIcon = function SvgBellIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2.25a.75.75 0 0 1 .75.75v.815c2.862.373 5.063 2.817 5.063 5.748v4.124l1.907 1.908a.728.728 0 0 1-.566 1.243l-.079-.009H4.925l-.08.009a.73.73 0 0 1-.778-.712.73.73 0 0 1 .213-.531l1.907-1.908V9.564c0-2.931 2.201-5.375 5.063-5.748V3a.75.75 0 0 1 .75-.75M7.688 9.563A4.31 4.31 0 0 1 12 5.25a4.31 4.31 0 0 1 4.313 4.313V14c0 .199.079.39.22.53l.719.72H6.748l.72-.72a.75.75 0 0 0 .22-.53zm6.585 8.544a.785.785 0 0 0-1.085-.242c-.426.27-.81.385-1.188.385s-.762-.115-1.187-.385a.785.785 0 0 0-1.086.242.785.785 0 0 0 .243 1.085c.605.385 1.258.558 2.03.558s1.425-.173 2.03-.558a.785.785 0 0 0 .243-1.085",
    clipRule: "evenodd"
  })));
};
export default SvgBellIcon;